import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

// Import the functions you need from the SDKs you need
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";

import { useState } from "react";
import { auth } from "../../Firebase";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const Auth = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((result) => {
        console.log("result", result);
        navigate("/");
      })
      .catch((e) => {
        console.log("exception", e);
      });
  };
  const register = (email, password) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        console.log("result", result);
        navigate("/");
      })
      .catch((e) => {
        console.log("exception", e);
      });
  };

  return (
    <Grid container justifyContent={"center"} width="100%" height={"75vh"}>
      <Stack justifyContent={"center"} spacing={2} minWidth={"400px"}>
        <Stack direction="row" justifyContent={"center"}>
          <h1>Welcome to ShopList</h1>
        </Stack>
        <TextField
          id="outlined-basic"
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <TextField
          id="outlined-basic"
          label="Password"
          variant="outlined"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <Stack spacing={1} direction="row" justifyContent={"center"}>
          <Button variant="contained" onClick={() => register(email, password)}>
            <PersonAddIcon style={{ padding: "5px" }} /> Register
          </Button>
          <Button variant="contained" onClick={() => login(email, password)}>
            <LoginIcon style={{ padding: "5px" }} /> Login
          </Button>
        </Stack>
      </Stack>
    </Grid>
  );
};

export default Auth;
